import { useContext, useEffect, useState } from "react";
 
import { MasterConfigContext } from "@/context/MasterConfigContext";
 
const ResultTally = ({
  electionPassedCategory = "",
  masterKey = "",
  stateHindi = "",
  constHindiName='',
}) => {
  
  // const currentPath = router?.asPath?.split("?")[0];
  // const size = useWindowSize();
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const showResultTally = electionKeys?.showResultTally;
  // console.log("showResultTally", masterKey);
  const height =   electionKeys?.resultPollHeight;
  const resultPollHeightTab = electionKeys?.resultPollHeightTab;

  const mobileHeight = electionKeys?.resultPollMobileHeight;

  // console.log("currentPath", size, height, mobileHeight);

  // const isResultRoute = currentPath === "/";
  const [screenWidth, setScreenWidth] = useState();
  // Check screen width only on the client side
  useEffect(() => {
    if (showResultTally && typeof window !== "undefined") {
      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      };

      setScreenWidth(window.screen.width); // Set initial width
      window.addEventListener("resize", handleResize);

      // Cleanup listener on unmount
      return () => window.removeEventListener("resize", handleResize);
    }
    
   
  }, []);
  return (
    <>
    

    {showResultTally ? (
      <div className="my-4 ">
        <div className="flex items-center h-full mb-2">
          <h2 className="font-bold font-devnagri text-2xl"> रिजल्ट टैली</h2>
        </div>
        <div>
          {screenWidth > 1300 ? (
            <iframe  
              title="loksabha exit poll"
              src={`${electionKeys?.showResultURL}`}
              style={{
                width: "100%",
                height: `${height}px`,
               
                margin: "0",
              }}
              scrolling="no"
            />
          ) : (
            <iframe
              title="loksabha exit poll  "
              src={`${electionKeys?.showResultURL}`}
              style={{
                width: "100%",
                // height: `${mobileHeight}px`
                height:
                  (screenWidth >= 700 && screenWidth <= 1000)
                    ? `${resultPollHeightTab}px`
                    : `${mobileHeight}px`,
                    margin: "0",
              }}
              scrolling="no"
            />
          )}
        </div>
      </div>
    ) : (
      <></>
    )}
  </>
  );
};

export default ResultTally;
